import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "./components/Loader";

// const Modal = lazy(() => import('./common/modal/modal'));
const HomePage = lazy(() => import("./components/login/homePage"));
const EligibilityFlow = lazy(() => import("./components/eligibility/eligibilityFlow"));
const BigCalendar = lazy(() => import("./components/calendar/calendar"));
const CountySelection = lazy(() => import("./components/countySelection/countySelection"));
const ClientForm = lazy(() => import("./components/clientForm/clientForm"));
const ConfirmAppointment = lazy(() => import("./components/confirmappointment"));
const AdditionalService = lazy(() => import("./components/additionalService/additionalService"));
const AppointmentList = lazy(() => import("./components/appointmentList/index"));
const ClientFormEdit = lazy(() => import("./components/clientFormEdit/clientFormEdit"));
const AlleghenyEligibility = lazy(() => import("./components/eligibility/alleghenyEligibility"));
const GreeneEligibility = lazy(() => import("./components/eligibility/greeneEligibility"));
const ButlerEligibility = lazy(() => import("./components/eligibility/butlerEligibility"));

const AppRoutes = () => {

    return (
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* <Route path="/selfScheduler/modal" element={<Modal />}></Route> */}
          <Route path="/selfScheduler/:ID" element={<HomePage />}></Route>
          <Route path="/selfScheduler/homePage" element={<HomePage />}></Route>
          <Route path="/selfScheduler/eligibilityFlow" element={<EligibilityFlow />}></Route>
          <Route path="/selfScheduler/calendar" element={<BigCalendar />}></Route>
          <Route path="/selfScheduler/countySelection" element={<CountySelection />}></Route>
          <Route path="/selfScheduler/clientForm" element={<ClientForm />}></Route>
          <Route path="/selfScheduler/confirmappointment" element={<ConfirmAppointment />}></Route>
          <Route path="/selfScheduler/additionalService" element={<AdditionalService />}></Route>
          <Route path="/selfScheduler/appointmentList" element={<AppointmentList />}></Route>
          <Route path="/selfScheduler/clientFormEdit" element={<ClientFormEdit />}></Route>
          <Route path="/selfScheduler/alleghenyEligibility" element={<AlleghenyEligibility />}></Route>
          <Route path="/selfScheduler/greeneEligibility" element={<GreeneEligibility />}></Route>
          <Route path="/SelfScheduler/butlerEligibility" element={<ButlerEligibility />}></Route>
    
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
